import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { BaseComponent } from '../../../components/BaseComponent';
import { VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Input } from '../../../components/Input';
import { Loader } from '../../../components/Loader';
import { FormField } from '../../../components/FormFields';
import { selectWork } from '../../Api/selectors';
import { requestOrehVehicleExport } from '../actions';
import { REQUEST_OREH_VEHICLE_EXPORT } from '../constants';

const Container = styled.div`
  .formFieldsWrapper {
    padding: 0 5px 0;
  }
  .subtitle {
    margin-bottom: 16px;
  }
  .inputField {
    width: 400px;
    max-width: 100%;
    margin-bottom: 16px;
  }
`;

const STATE = {
  value: {
    regPlate: '',
    meldcode: '',
    tellerstand: '',
    firstName: '',
    surname: '',
    city: '',
    street: '',
    legitimationTypeCode: '',
    legitimationPlace: '',
    identificationNumber: '',
    legitimationCountryCode: '',
  },
};

class DetailsOrehVehicleExport extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  componentDidMount() {
    if (this.vehicle) {
      this.setState({
        ...this.state,
        value: {
          ...this.state.value,
          regPlate: this.vehicle.regplate,
          meldcode: this.vehicle.meldcode,
          tellerstand: this.vehicle.mileage,

          firstName: '',
          surname: '',
          city: '',
          street: '',
          legitimationTypeCode: '',
          legitimationPlace: '',
          identificationNumber: '',
          legitimationCountryCode: '',
        },
      });
    }
  }

  submit(e) {
    e.stopPropagation();
    e.preventDefault();

    this.props.requestOREHVehicleExport(this.vehicle.id, { ...this.state.value });
  }

  onInputChange(e) {
    this.setState({ ...this.state, value: { ...this.state.value, [e.target.name]: e.target.value } });
  }

  render() {
    return (
      <Container>
        <VBox gap={14}>
          <VBox>
            <form onSubmit={(e) => this.submit(e)}>
              <div className="formFieldsWrapper">
                <h3 className="subtitle">{this.lbl('vehicle.overview.title')}:</h3>

                <FormField className="inputField" label={this.lbl('vehicle.filter.regplate')}>
                  <Input
                    name="regPlate"
                    value={this.state.value.regPlate}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>

                <FormField className="inputField" label={this.lbl('vehicle.filter.meldcode')}>
                  <Input
                    name="meldcode"
                    value={this.state.value.meldcode}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('vehicle.filter.milage')}>
                  <Input
                    name="tellerstand"
                    value={this.state.value.tellerstand}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>

                <h3 className="subtitle">{this.lbl('invoice.create.buyer')}:</h3>
                <FormField className="inputField" label={this.lbl('user.details.name')}>
                  <Input
                    required
                    name="firstName"
                    value={this.state.value.firstName}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('user.details.surname')}>
                  <Input
                    name="surname"
                    value={this.state.value.surname}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('company.details.city')}>
                  <Input
                    name="city"
                    value={this.state.value.city}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('user.info.street')}>
                  <Input
                    name="street"
                    value={this.state.value.street}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('user.info.legitimationTypeCode')}>
                  <Input
                    name="legitimationTypeCode"
                    value={this.state.value.legitimationTypeCode}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('user.info.legitimationPlace')}>
                  <Input
                    name="legitimationPlace"
                    value={this.state.value.legitimationPlace}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('user.info.identificationNumber')}>
                  <Input
                    name="identificationNumber"
                    value={this.state.value.identificationNumber}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
                <FormField className="inputField" label={this.lbl('user.info.legitimationCountryCode')}>
                  <Input
                    name="legitimationCountryCode"
                    value={this.state.value.legitimationCountryCode}
                    style={{width: '100%'}}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </div>
              <Button type="submit" disabled={this.props.loading} onClick={e => this.submit(e)}>
                {this.props.loading ? <Loader small/> : 'Request Export'}
              </Button>
            </form>
          </VBox>
          {!!this.vehicle.oreh_export_response?.length && (
            <VBox>
              <h3 className="subtitle">Response:</h3>
              {this.vehicle.oreh_export_response}
            </VBox>
          )}
        </VBox>
      </Container>
    );
  }
}

DetailsOrehVehicleExport.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  loading: selectWork(REQUEST_OREH_VEHICLE_EXPORT),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  requestOREHVehicleExport(vehicleId, data, callback) {
    dispatch(requestOrehVehicleExport(vehicleId, data, callback));
  },
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OrehVehicleExport = compose(withConnect, withRouter, injectIntl)(DetailsOrehVehicleExport);
